// Source URLs can contain search terms or affiliate/session tokens. Capture
// only the destination's host and path, never query parameters or link text.
export const linkDestination = (
  href: string,
  base?: string
): { destinationHost: string; destinationPath: string } | null => {
  try {
    const url = new URL(href, base)
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      return null
    }
    return { destinationHost: url.hostname, destinationPath: url.pathname }
  } catch {
    return null
  }
}
